<template>
  <div>
    {{currentValue.toLocaleString('en-US', {maximumFractionDigits:2})}}
  </div>
</template>

<script>
export default {
  name: "CounterIncrement",
  data() {
    return {
      refreshInterval: 1000,
      currentValue: 0,
    }
  },
  props: {
    counterIncrement: {
      type: String,
      required: true
    },
    counterIncrementInterval: {
      type: String,
      required: true
    },
    startValue: {
      type: String,
      required: true
    },
  },
  methods: {
    incrementCounter() {
      this.currentValue += parseFloat(this.counterIncrement)
    },
    startCounter() {
      setInterval(this.incrementCounter, parseInt(this.counterIncrementInterval) * 1000)
    }
  },
  mounted() {
    this.currentValue = parseFloat(this.startValue)
    this.startCounter()
  }
}
</script>

<style scoped>

</style>